/**
 * reviveTimestamps — turn Admin-SDK Timestamps back into Firestore
 * Timestamp-like objects. Walter 2026-08-21.
 *
 * The read fallback (/api/listChanges) returns list docs as JSON, so
 * Timestamps arrive as `{_seconds, _nanoseconds}`. The rest of the app expects
 * `.toMillis()` / `.toDate()` — `useData` reads `updatedAt.toMillis()` for the
 * conflict BASELINE, and the panels read `conflictPendingReview` and
 * `editLock.*`. Get this wrong and a polled list silently loses its baseline,
 * which would be worse than not polling at all.
 *
 * Walks the whole object rather than naming fields, so a timestamp nested
 * somewhere we forgot (editLock.startedAt was exactly that) still survives.
 *
 * Lives apart from readViaApi.js because importing that pulls in firebase/auth,
 * which drags undici into Jest and explodes on `TextEncoder is not defined`.
 * Keeping the pure half separate is what makes it testable.
 */
export function reviveTimestamps(value) {
  if (!value || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(reviveTimestamps);
  const s = value._seconds;
  const n = value._nanoseconds;
  if (typeof s === 'number' && typeof n === 'number') {
    const ms = s * 1000 + Math.floor(n / 1e6);
    return { toMillis: () => ms, toDate: () => new Date(ms), seconds: s, nanoseconds: n };
  }
  const out = {};
  for (const [k, v] of Object.entries(value)) out[k] = reviveTimestamps(v);
  return out;
}
